import { pathOr } from 'ramda';

import { IState } from '../../store';

export const getGaLabel = (state: IState) => {
  return pathOr('', ['offerData', 'newObject', 'gaLabel'], state);
};
